import { Card, FormSection } from "../../components/ui";
import { useBranding } from "../../context/BrandingContext";

/**
 * System preferences.
 *
 * Language, currency and timezone are properties of the BUSINESS, so they are
 * edited once in Business details rather than duplicated here with a second
 * source of truth. This section reports the effective values and says where
 * they are changed. Date/time FORMAT selection is not offered because no
 * centralised datetime layer exists yet — a picker that changed nothing would
 * be worse than its absence.
 */
export function SystemSettingsSection() {
  const { language } = useBranding();
  const ar = language === "ar";

  return (
    <Card>
      <FormSection legend={ar ? "تفضيلات النظام" : "System preferences"}>
        <dl className="divide-y divide-line-hairline">
          {[
            [ar ? "لغة الواجهة" : "Interface language", ar ? "العربية" : "English"],
            [ar ? "الاتجاه" : "Direction", ar ? "من اليمين إلى اليسار" : "Left to right"],
            [ar ? "المنطقة الزمنية" : "Timezone", "Asia/Riyadh"],
            [ar ? "التقويم" : "Calendar", ar ? "ميلادي" : "Gregorian"],
            [ar ? "العملة" : "Currency", "SAR"],
          ].map(([k, v]) => (
            <div key={k} className="flex items-baseline justify-between gap-3 py-2.5">
              <dt className="text-sm text-ink-700">{k}</dt>
              <dd className="text-sm font-medium text-ink-900">{v}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-3 text-xs text-muted-foreground">
          {ar
            ? "تُضبط اللغة والعملة والمنطقة الزمنية من «بيانات المغسلة» — مصدر واحد لكل قيمة."
            : "Language, currency and timezone are set in Business details — one source per value."}
        </p>
      </FormSection>
    </Card>
  );
}
